import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Input } from 'antd';
import { usePrevious } from '@hooks';
import React, { useEffect, useState } from 'react';
export const UserTableSearch = ({ onSearch, value = '' }) => {
    const [searchValue, setSearchValue] = useState(value);
    const previousValue = usePrevious(value);
    useEffect(() => {
        if (value !== previousValue && value !== searchValue) {
            setSearchValue(value);
            onSearch(value);
        }
    }, [onSearch, previousValue, searchValue, value]);
    return (React.createElement(Input.Search, { allowClear: true, className: 'user-email-filter', enterButton: true, onChange: (e) => setSearchValue(e.target.value), onSearch: onSearch, placeholder: ADMIN_DASHBOARD_COPY.SEARCH_USERS_PLACEHOLDER, value: searchValue }));
};
